import { AccountSolution, Jwt, JwtRole, UserRole } from '@thingslog/repositories';
import { submitSessionLogout } from '@thingslog/utils';
import { clearSessionUser, getSessionUser } from './sessionUser';

/**
 * Reads the user that the backend session resolved for us (GET /api/me). The name is kept for the
 * call sites - there is no token in the browser any more.
 */
export default class JwtValidator {
  public decodedToken: Jwt | null;
  public isValidToken: boolean;

  public constructor(user?: Jwt | null) {
    this.decodedToken = user ?? getSessionUser();
    this.isValidToken = this.decodedToken !== null;
  }

  // #region public methods
  public hasRole = (userRole: UserRole): boolean => {
    if (!this.decodedToken) return false;
    let hasRole = false;

    try {
      this.decodedToken.roles.forEach((role: JwtRole) => {
        if (role.authority === userRole) {
          hasRole = true;
        }
      });
    } catch {
      return false;
    }

    return hasRole;
  };

  public hasRoles = (userRoles: UserRole[]): boolean => {
    if (!this.decodedToken) return false;
    let hasRole = false;

    try {
      this.decodedToken.roles.forEach((role: JwtRole) => {
        if (userRoles.includes(role.authority)) {
          hasRole = true;
        }
      });
    } catch {
      return false;
    }

    return hasRole;
  };

  public hasCompanySelectionRole = (): boolean => {
    return this.hasRoles(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']);
  };

  public isSolution = (solution: AccountSolution): boolean => {
    if (!this.decodedToken) return false;

    return this.decodedToken.solution === solution;
  };

  public logout = (): void => {
    clearSessionUser();
    localStorage.removeItem('selectedCompany');
    submitSessionLogout();
  };
  // #endregion
}
